module.exports = __webpack_public_path__ + "img/pumpkin-roll.506448c2.jpg";